import { FC } from 'react';

import { ImagePlaceholder, ImagePlaceholderWrapper, ImageWrapper } from './AuthorDetails.styles';
import { AuthorImagePlaceholder } from './AuthorImagePlaceholder';

export type AuthorImageProps = {
    image?: string;
    alt?: string;
};

export const AuthorImage: FC<AuthorImageProps> = ({ image, alt }) => {
    return (
        <ImageWrapper>
            {image ? (
                <img src={image} alt={alt || ''} />
            ) : (
                <ImagePlaceholderWrapper aria-hidden={true}>
                    <ImagePlaceholder>
                        <AuthorImagePlaceholder />
                    </ImagePlaceholder>
                </ImagePlaceholderWrapper>
            )}
        </ImageWrapper>
    );
};
